import React, { useEffect, useState, useRef } from "react";
import { LoggedInView } from "../common/LoggedInView";
import { resetSendEmail, sendEmailRecommended } from "../../store/reducers/ContactsSlice";
import { VendorContact } from "../../models/VendorContact";
import { useAppDispatch, useAppSelector } from "../../utils/Hooks";
import { RequestStatus } from "../../utils/Enums";

interface RecommendedVendorsEmailScreenProps {}

export const RecommendedVendorsEmailScreen: React.FC<RecommendedVendorsEmailScreenProps> = () => {
    const dispatch = useAppDispatch();
    const contactsState = useAppSelector((state) => state.contacts);

    const [recipients, setRecipients] = useState<VendorContact[]>([]);
    const [subjectEstonian, setSubjectEstonian] = useState<string>("");
    const [contentEstonian, setContentEstonian] = useState<string>("");
    const [subjectEnglish, setSubjectEnglish] = useState<string>("");
    const [contentEnglish, setContentEnglish] = useState<string>("");
    const [success, setSuccess] = useState<boolean>(false);

    const sendEmailStatus = contactsState.sendEmailStatus;

    useEffect(() => {
        if (sendEmailStatus === RequestStatus.Success) {
            setSuccess(true);
            dispatch(resetSendEmail());
        }
    }, [sendEmailStatus]);

    useEffect(() => {
        const storedRecipients = sessionStorage.getItem('selectedRecommendations');
        if (storedRecipients) {
            setRecipients(JSON.parse(storedRecipients) as VendorContact[]);
        }
    }, []);

    const sendEmails = () => {
        const emailData = {
            subjectEst: subjectEstonian,
            contentEst: contentEstonian,
            subjectEng: subjectEnglish,
            contentEng: contentEnglish,
        };
        dispatch(sendEmailRecommended(emailData));
    };

    const handleContactButtonClick = (text: string, language: string, contentRef: React.RefObject<HTMLTextAreaElement>) => {
        if (language === 'est') {
            setSubjectEstonian(subjectEstonian + text);
        } else {
            setSubjectEnglish(subjectEnglish + text);
        }
        contentRef.current?.focus();
    };

    const handleSignatureButtonClick = (text: string, language: string, contentRef: React.RefObject<HTMLTextAreaElement>) => {
        if (language === 'est') {
            setContentEstonian(contentEstonian + text);
        } else {
            setContentEnglish(contentEnglish + text);
        }
        contentRef.current?.focus();
    };

    const contentEstonianRef = useRef<HTMLTextAreaElement>(null);
    const contentEnglishRef = useRef<HTMLTextAreaElement>(null);

    return (
        <LoggedInView fullWidth={false}>
            <h1>Saada E-mail</h1>
            {success ? (
                <div className="message msg-ok">
                    <div>
                        <h2>Kirjad saadetud</h2>
                    </div>
                </div>
            ) : (
                <div className="form">
                    <form method="post">
                        <h2><span>Saada mail</span></h2>
                        <table className="form">
                            <tbody>
                            <tr>
                                <th>Pealkiri eesti keeles:</th>
                                <td>
                                    <input
                                        type="text"
                                        id="subjectEstonian"
                                        name="subjectEstonian"
                                        className="text"
                                        value={subjectEstonian}
                                        onChange={(e) => setSubjectEstonian(e.target.value)}
                                    />
                                    <button
                                        style={{ border: "1px solid black", marginLeft: "5px" }}
                                        type={'button'}
                                        onClick={() => handleContactButtonClick("[plea]", "est", contentEstonianRef)}
                                    >
                                        [plea]
                                    </button>
                                </td>
                            </tr>
                            <tr>
                                <th>Adressaadid:</th>
                                <td>
                                    {recipients
                                        .filter((contact: VendorContact) => contact.language === "est")
                                        .map((contact: VendorContact) => (
                                            <React.Fragment key={contact.id}>
                                                <strong>{contact.name}</strong> - {contact.emails}<br />
                                            </React.Fragment>
                                        ))}
                                </td>
                            </tr>
                            <tr>
                                <th>Sisu eesti keeles:</th>
                                <td>
                                    <button
                                        style={{ border: "1px solid black", marginRight: "5px" }}
                                        type={'button'}
                                        onClick={() => handleSignatureButtonClick("[contact]", "est", contentEstonianRef)}
                                    >
                                        [contact]
                                    </button>
                                    <button
                                        style={{ border: "1px solid black", marginRight: "5px" }}
                                        type={'button'}
                                        onClick={() => handleSignatureButtonClick("[signature]", "est", contentEstonianRef)}
                                    >
                                        [signature]
                                    </button>
                                    <br/><br/>
                                    <textarea
                                        ref={contentEstonianRef}
                                        id="contentEstonian"
                                        name="contentEstonian"
                                        style={{ width: '500px', height: '200px', whiteSpace: 'pre-wrap' }}
                                        cols={60}
                                        rows={10}
                                        className="small"
                                        value={contentEstonian}
                                        onChange={(e) => setContentEstonian(e.target.value)}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>Pealkiri inglise keeles:</th>
                                <td>
                                    <input
                                        type="text"
                                        id="subjectEnglish"
                                        name="subjectEnglish"
                                        className="text"
                                        value={subjectEnglish}
                                        onChange={(e) => setSubjectEnglish(e.target.value)}
                                    />
                                    <button
                                        style={{ border: "1px solid black", marginLeft: "5px" }}
                                        type={'button'}
                                        onClick={() => handleContactButtonClick("[plea]", "eng", contentEnglishRef)}
                                    >
                                        [plea]
                                    </button>
                                </td>
                            </tr>
                            <tr>
                                <th>Adressaadid:</th>
                                <td>
                                    {recipients
                                        .filter((contact: VendorContact) => contact.language != "est")
                                        .map((contact: VendorContact) => (
                                            <React.Fragment key={contact.id}>
                                                <strong>{contact.name}</strong> - {contact.emails}<br />
                                            </React.Fragment>
                                        ))}
                                </td>
                            </tr>
                            <tr>
                                <th>Sisu inglise keeles:</th>
                                <td>
                                    <button
                                        style={{ border: "1px solid black", marginRight: "5px" }}
                                        type={'button'}
                                        onClick={() => handleSignatureButtonClick("[contact]", "eng", contentEnglishRef)}
                                    >
                                        [contact]
                                    </button>
                                    <button
                                        style={{ border: "1px solid black", marginRight: "5px" }}
                                        type={'button'}
                                        onClick={() => handleSignatureButtonClick("[signature]", "eng", contentEnglishRef)}
                                    >
                                        [signature]
                                    </button>
                                    <br/><br/>
                                    <textarea
                                        ref={contentEnglishRef}
                                        id="contentEnglish"
                                        name="contentEnglish"
                                        style={{ width: '500px', height: '200px', whiteSpace: 'pre-wrap' }}
                                        cols={60}
                                        rows={10}
                                        className="small"
                                        value={contentEnglish}
                                        onChange={(e) => setContentEnglish(e.target.value)}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th></th>
                                <td>
                                    <div className="action clear">
                                        <p>
                                            <button type="button" onClick={sendEmails}>
                                                <span><strong>Saada </strong></span>
                                            </button>
                                        </p>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </form>
                </div>
            )}
        </LoggedInView>
    );
};
